import { localizeNames } from "../../../common/helpers/common";
import { TalentExclusivity } from "../../talents/talentAPI";

export type ExclusivityFormatLabels = {
  allWorkTitles: string;
  allOrganizations: string;
  allWorkLocations: string;
};

export const formatExclusivityEntry = (
  exclusivity: TalentExclusivity,
  workTitleTranslations: Record<string, string>,
  labels: ExclusivityFormatLabels,
): string => {
  const workTitles = exclusivity.workTitles?.length
    ? localizeNames(workTitleTranslations, exclusivity.workTitles)
    : labels.allWorkTitles;

  return [
    exclusivity.customerCompanyName,
    exclusivity.customerOrganizationName || labels.allOrganizations,
    exclusivity.workLocationName || labels.allWorkLocations,
    workTitles,
  ].join(", ");
};
